import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const TriangleDown = (props: SvgProps) => (
  <Svg
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <Path fill={props.color ?? '#fff'} d="M6.25 8.75 10 12.5l3.75-3.75" />
  </Svg>
);
export default TriangleDown;
